/* global document, alert*/

import React from 'react'
import PropTypes from 'prop-types'

import FlatButton from 'material-ui/FlatButton'
import { connect } from 'react-redux'
import * as firebase from 'firebase'

import withSettingsCard from '../withSettingsCard'
import upload from 'resources/upload_icon.png'
import PhotoItem from 'schedule/common/modules/photos/PhotoItem'
import CircularProgress from 'material-ui/CircularProgress'

const LOGO_PREVIEW_SIZE = 200

class CompanyLogo extends React.Component {

  static propTypes = {
    style: PropTypes.object,
    teamId: PropTypes.string.isRequired,
    uploadedCompanyLogo: PropTypes.bool
  }

  constructor(props) {
    super(props)
    this.state = {}
  }

  getCompanyLogoStoragePath = teamId => {
    return `team_logo/${teamId}/logo`
  }

  handleUploadClicked = event => {
    event.preventDefault()
    document.querySelector('input[name=\'company-logo-upload\']').click()
  }

  onFileInputChange = event => {
    const file = event.target.files[0]
    if (file) {
      if (!file.type.match('image/png') && !file.type.match('image/jpeg')) {
        alert('Error, expeted image file.')
      }
      else {
        this.setState({ uploading: true })
        firebase.storage()
          .ref(this.getCompanyLogoStoragePath(this.props.teamId)).put(file)
          .then(() => {
            return firebase.database()
              .ref(`teams/${this.props.teamId}/metadata/uploadedCompanyLogo`)
              .set(true)
          })
          .then(() => {
            this.setState({ uploading: false })
          })
      }
    }
  }

  render() {
    return (
      <div style={{ ...this.props.style, ...styles.container }}>
        <div style={styles.header}>Organization Logo</div>
        <div style={styles.subheader}>Upload your organization's logo to use in Invoices and Estimates.</div>
        <FlatButton
          label={this.props.uploadedCompanyLogo ? 'Change' : 'Upload'}
          style={styles.actionButton}
          labelStyle={styles.buttonLabel}
          icon={<img src={upload} height={24} width={24} />}
          onTouchTap={this.handleUploadClicked}>
          <input style={{ display: 'none' }} type='file' name='company-logo-upload' onChange={this.onFileInputChange}
            multiple />
        </FlatButton>
        { (this.props.uploadedCompanyLogo || this.state.uploading) &&
          <div style={styles.photoContainer}>
            { this.state.uploading
              ? <div style={styles.progress}><CircularProgress thickness={2} size={LOGO_PREVIEW_SIZE/2} /></div>
              : <PhotoItem
                disableDeletion={true}
                storagePath={this.getCompanyLogoStoragePath(this.props.teamId)}
                width={LOGO_PREVIEW_SIZE}
                height={LOGO_PREVIEW_SIZE} />
            }
          </div>
        }
      </div>
    )
  }

}

const styles = {
  container: {
    textAlign: 'left',
    paddingTop: 20,
    paddingBottom: 20,
    marginLeft: 24,
    marginRight: 24
  },
  header: {
    fontSize: 18,
    fontWeight: 500,
    marginBottom: 8
  },
  subheader: {
    fontSize: 14,
    fontWeight: 300
  },
  actionButton: {
    borderRadius: 3,
    backgroundColor: '#356992',
    marginTop: 18
  },
  buttonLabel: {
    color: 'white',
    fontSize: 14,
    fontWeight: 400
  },
  photoContainer: {
    width: LOGO_PREVIEW_SIZE,
    height: LOGO_PREVIEW_SIZE,
    marginTop: 32,
    border: '2px dashed #E0E0E0'
  },
  progress: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: LOGO_PREVIEW_SIZE,
    height: LOGO_PREVIEW_SIZE
  }
}

const mapStateToProps = state => ({
  teamId: state.firebase.team.metadata.value.id,
  uploadedCompanyLogo: state.firebase.team.metadata.value.uploadedCompanyLogo
})

export default connect(mapStateToProps)(withSettingsCard(CompanyLogo))



// WEBPACK FOOTER //
// ./src/settings/modules/companyLogo/CompanyLogo.js